module.exports = __webpack_public_path__ + "img/tablet-white.3fd6b8f7.svg";